<mat-form-field appearance="outline" class="col-12">
    <mat-label>{{ fieldObject.fieldName }}</mat-label>
    <input [type]="fieldObject.fieldType"
           class="form-control key"
           [formControl]="formControlRef"
           maxlength="{{maxlength}}"
           (keyup)="handleLength()"
           matInput
           id="card-cvv"
           [autocomplete]="fieldObject.autoCompleteName"
           >
    <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
      {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
    </mat-error>
  </mat-form-field>
